import {
	createActionsHook,
	type BoundActions,
	type HookActionsFunction,
	type StoreActionApi,
} from 'react-sweet-state';

import type { State } from './State';
import { store } from './store';

export const useAgentDebugModalActions: HookActionsFunction<
	BoundActions<
		State,
		{
			openModal: ({
				messageId,
				conversationId,
			}: {
				messageId: string;
				conversationId: string;
			}) => ({ setState }: StoreActionApi<State>) => Promise<void>;
			closeModal: () => ({ setState }: StoreActionApi<State>) => void;
		}
	>
> = createActionsHook(store);
